import { v4 as uuidv4 } from 'uuid';
export default class StatsApi {

  constructor(faqIdentifier) {
    this.baseUrl = process.env.MIX_WEBCOMET_BASE_URL;
    this.faqIdentifier = faqIdentifier;
    this.source = 'faq-portal';

    this.isNewSession = false;

    const storedSessionId = window.sessionStorage.getItem(this.getSessionKey());
    if (storedSessionId === null) {
      this.sessionId = this.createSession();
    } else {
      this.sessionId = storedSessionId;
    }
  }

  getSessionKey() {
    return `urn:${this.source}:faq:${this.faqIdentifier}`;
  }

  createSession() {
    const sessionId = uuidv4();
    window.sessionStorage.setItem(this.getSessionKey(), sessionId);
    this.isNewSession = true;

    return sessionId;
  }

  trackView(payload) {
    if (this.isNewSession) {
      this.track('view', payload);
    }
  }

  trackOpenQuestion(payload) {
    this.track('open_question', payload);
  }

  trackSearch(payload) {
    this.track('search', payload);
  }

  fetchVotes(userFingerprint) {
    const url = new URL(
      `${this.baseUrl}/api/internal/faq/${this.faqIdentifier}/vote`
    );

    const params = {
      user_fingerprint: userFingerprint,
    };

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    return window.fetch(url.toString(), {
      method: 'get',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async track(type, payload) {
    const data = {
      model: 'faq',
      identifier: this.faqIdentifier,
      type: type,
      source: this.source,
      session: this.sessionId,
      payload: payload,
    };

    return window.fetch(`${this.baseUrl}/api/internal/statistics`, {
      method: 'post',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }
}
